import { createLucideIcon } from 'lucide-react';
export const TrashIcon = createLucideIcon('trash', [
  [
    'path',
    {
      d: 'M10 5.08579C10 4.30474 10 4.78105 10 4C10 3.21896 14.6344 3.21896 14.6344 4C14.6344 4.78105 14.6344 4.30474 14.6344 5.08579',
      key: 'up1tff',
    },
  ],
  [
    'path',
    {
      d: 'M10 8.58578V12.5858V16.5858',
      key: '4pil83',
    },
  ],
  [
    'path',
    {
      d: 'M12.5 8.58578V12.5858V16.5858',
      key: '1cbvpg',
    },
  ],
  [
    'path',
    {
      d: 'M15 8.58578V12.5858V16.5858',
      key: '1buanh',
    },
  ],
  [
    'path',
    {
      d: 'M21 5.5H19.5',
      key: '6c4dhd',
    },
  ],
  [
    'path',
    {
      d: 'M3.5 5.5H5',
      key: '1hgv5b',
    },
  ],
  [
    'path',
    {
      d: 'M5 5.5H19.5',
      key: 'hcj1g7',
    },
  ],
  [
    'path',
    {
      d: 'M5 5.5L6.5 20.5858H18L19.5 5.5',
      key: 'ry9qgh',
    },
  ],
]);
